import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import "./LayerLink.css";

const LayerLink = ({ content, checked, onToggle, type = "toggle" }) => {
  if (type === "toggle") {
    return (
      <div className="LayerLinkToggle">
        <span className="LayerLinkLabel">{content} :</span>

        <InputSwitch
          checked={checked}
          onChange={() => {
            if (checked && onToggle) {
              onToggle(); 
            }
          }}
        />
      </div>
    );
  }

  return (
    <span className="LayerLink" onClick={onToggle}>
      {content}
    </span>
  );
};

export default LayerLink;
